import React from "react";
import "./styles.css";

const ToggleSwitch = ({ Name, checked, onChange }) => {
  const handleChange = (e) => {
    onChange(e);
  };
  return (
    <div className="toggle-switch">
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        name={Name}
        checked={checked}
        onChange={handleChange}
        id={Name}
      />
      <label className="toggle-switch-label" htmlFor={Name}>
        <span className="toggle-switch-inner" />
        <span className="toggle-switch-switch" />
      </label>
    </div>
  );
};

export default ToggleSwitch;
